export default __webpack_public_path__ + "static/media/add_icon-inactive.5cc80e0a.svg";